/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../../../../utilities/helpers';

export const EmptyAccountTransactionsImage = ({ showEmptySearchResult }) => (
  <img
    style={{ maxWidth: '100%' }}
    src={
      showEmptySearchResult
        ? dynamicAssets('./assets/images/no-deposit.png')
        : dynamicAssets('./assets/images/no_transactions_icon.png')
    }
    alt="no_transactions_icon"
  />
);

EmptyAccountTransactionsImage.propTypes = {
  showEmptySearchResult: PropTypes.bool,
};

EmptyAccountTransactionsImage.defaultProps = {
  showEmptySearchResult: false,
};
